import * as React from 'react';
import { CONSTANTS } from '../../../assets/UIConstants';

interface Props {
    height?: number;
    width?: number;
    strokeWidth?: number;
    color?: string;
}

class Line extends React.Component<Props, {}> {

    public static defaultProps: Partial<Props> = {
        color: CONSTANTS.COLORS.THEME_BLUE,
    };

    public render(): JSX.Element {
        return (
            <svg 
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-2624.377 4431.773 2 74.548"
                height={this.props.height}
                width={this.props.width}
            >
                <line 
                    id="Line" 
                    data-name="Line"
                    fill="none" 
                    strokeWidth={this.props.strokeWidth} 
                    stroke={this.props.color} 
                    y2="74.548" 
                    transform="translate(-2623.377 4431.773)"
                />
            </svg>
        );
    }
}

export default Line;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/svgs/Line.tsx